import styled from "styled-components";
import Theme from "../../Styles/Themes";
import config from "../../Config/config.json"
import { GetColors } from '../../util/Colors';

export const Container = styled.button`
    align-items: center;
    background: ${props => props.$color ? GetColors(props.$color).background : Theme[config.theme].colors.buttonBackground};
    border: ${props => props.$color ? GetColors(props.$color).border : 'none'};
    border-radius:  ${props => props.$borderRadius ? props.$borderRadius : '5px'};
    box-shadow: ${props => props.$color && GetColors(props.$color).boxShadow};
    box-sizing: border-box;
    color: ${props => props.$color ? GetColors(props.$color).color : Theme[config.theme].colors.secondaryFontColor};
    cursor: pointer;
    display: flex;
    float: ${props => props.$float && props.$float};
    font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.labels[config.fontSize].weight};
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    gap: 10px;
    height: ${props => props.$height ? props.$height : 'fit-content'};
    justify-content: center;
    padding: ${props => props.$padding ? props.$padding : '20px'};
    position: ${props => props.$position ? props.$position : 'none'};
    right: ${props => props.$position && (props.$width === '36px' ? '-16px' : '-20px')};
    top: ${props => props.$position && (props.$width === '36px' ? '-16px' : '-20px')};
    width: ${props => props.$width};
    &:hover {
        background: ${props => props.$color ? GetColors(props.$color).hoverbg : Theme[config.theme].colors.buttonBackgroundHover};
        color: ${props => props.$color ? GetColors(props.$color).hovercolor : Theme[config.theme].colors.secondaryFontColor};
        border: ${props => props.$color ? GetColors(props.$color).hoverborder : Theme[config.theme].colors.secondaryFontColor};
    }
    /* Personaliza hover dos icones */
    &:hover .icon path {
        fill: ${props => props.$color && GetColors(props.$color).hovercolor};
        // stroke: ${props => props.$color && GetColors(props.$color).hovercolor};
    }
    &:focus {
        ${props => props.$color ? GetColors(props.$color).background :  'background:' + Theme[config.theme].colors.buttonBackgroundFocus};
    }
    &:disabled {
        background: ${GetColors('disabled').background};
        border: ${GetColors('disabled').border};
        color: ${GetColors('disabled').color};
    }
`;